export default __webpack_public_path__ + "static/media/nhanhvn.48b43300.png";